import React from 'react';
import ResponsiveMulti from 'app/components/responsive/ResponsiveMulti';
import InviteFriendDesktop from 'app/components/friends/banners/InviteFriendDesktop';
import InviteFriendMobile from 'app/components/friends/banners/InviteFriendMobile';


type Props = {};

class InviteFriend extends React.Component {
  props: Props;

  render() {
    return (
      <ResponsiveMulti>
        {(matches) => {
          if (matches.mobile) {
            return (<InviteFriendMobile {...this.props} />);
          }
          return (<InviteFriendDesktop {...this.props} />);
        }}
      </ResponsiveMulti>
    );
  }
}

export default InviteFriend;
